export default __webpack_public_path__ + "static/media/listViewMobile.fbc308d7.svg";